import flatten from 'lodash.flatten';
import formatNumber from 'helpers/formatNumber';

const getSortedGroupsWithValues = (
  sortedGroups: any,
  entityData: any,
  isTopList?: boolean
): any => {
  const sorted = sortedGroups.map((group: any) => {
    return group.map((item: any) => {
      const rawValue = entityData[item.key];
      item.rawValue = rawValue;
      if (item.label.toLowerCase() === 'change') {
        item.value = formatNumber(rawValue, 'trend');
        item.isPositive = rawValue === 0 ? null : rawValue > 0;
      } else {
        item.value = formatNumber(rawValue, 'number');
      }
      return item;
    });
  });

  if (isTopList) {
    return [
      flatten(sorted).sort((a: any) =>
        a.label.toLowerCase() === 'change' ? 1 : -1
      ),
    ];
  }
  return sorted;
};

export default getSortedGroupsWithValues;
